import { toast } from "react-toastify";
import NProgress from 'nprogress';
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getImageSignedUrl, getUserData, getUserId } from "../../Base/helper/baseFunctions";
import { assignTokenContent } from "./MailHelper";
import { EmailHelper } from "../../Ancillary/Email/helper/EmailHelper";
import { BaseEmailTemplate2 } from "../../Base/views/BaseEmailTemplate";
import { renderEmail } from "react-html-email";

// --- Employee Canteen Token Configuration Helpers ---

export const GetEmployeeTokenConfigHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/canteen/getEmployeeCanteenManagement`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            month: params?.month,
            year: params?.year,
            user_id: getUserId(),
            ats_work_location_json: params?.ats_work_location_json || null
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Token retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve employee token", hasError: true, data: err?.response?.data }
    });
};

export const AddEmployeeTokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    const generatedToken ={
        uuid: params?.uuid,
        employee_name: params?.employee_name,
        tokens: params?.tokens,
        issued: params?.formattedToday,
        company: getUserData().company_full_name,
    };
    const subject = `Meal Token - ${generatedToken.uuid || ""}`;
    const company_logo = await getImageSignedUrl(params?.company_logo);
    return await axiosInstance(`/canteen/addEmployeeCanteenManagement`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            uuid: params?.uuid,
            month: params?.month,
            year: params?.year,
            tab: params?.tab || "Employee",
            record_date: params?.record_date,
            token: params?.tokens,
            comments: params?.comments || "",
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Token config assigned successfully");
        const emailContent = assignTokenContent({ generatedToken });
        EmailHelper({
            to: params?.contact_info,
            subject: subject,
            content: renderEmail(
                    <BaseEmailTemplate2 company_logo={company_logo}>
                    {emailContent}
                    </BaseEmailTemplate2>
                ),
            });
        return { message: "Token config assigned successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to assign Token Configured", hasError: true, data: err?.response?.data }
    });
};

export const UpdateEmployeeTokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    const generatedToken ={
        uuid: params?.uuid,
        employee_name: params?.employee_name,
        tokens: params?.tokens,
        issued: params?.formattedToday,
        company: getUserData().company_full_name,
    };
    const subject = `Meal Token - ${generatedToken.uuid || ""}`;
    const company_logo = await getImageSignedUrl(params?.company_logo);
    return await axiosInstance(`/canteen/updateEmployeeCanteenManagement`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            uuid:  params?.uuid,
            month: params?.month,
            year: params?.year,
            tab: params?.tab || "Employee",
            record_date: params?.record_date,
            token: params?.tokens,
            comments: params?.comments,
            employee_canteen_management_id: params?.employee_canteen_tokens_maping_id,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Token config updated successfully");
        const emailContent = assignTokenContent({ generatedToken });
        EmailHelper({
            to: params?.contact_info,
            subject: subject,
            content: renderEmail(
                    <BaseEmailTemplate2 company_logo={company_logo}>
                    {emailContent}
                    </BaseEmailTemplate2>
                ),
            });
        return { message: "Token config updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update Token Configured", hasError: true, data: err?.response?.data }
    });
};

export const DeleteEmployeeTokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/canteen/deleteEmployeeCanteenManagement`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_canteen_management_id: params?.employee_canteen_tokens_maping_id,
            month: params?.month,
            year: params?.year,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Token config deleted successfully");
        return { message: "Token config deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to remove token config", hasError: true, data: err?.response?.data }
    });
};

export const GetCanteenManagementRecordHelper = async (params) => {
    return await axiosInstance(`/canteen/getCanteenManagementRecords`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name ? params?.domain_name : getDomain(),
            canteen_management_regions_pk: params?.canteen_management_regions_pk,
            from_date: params?.from_date,
            to_date: params?.to_date,
            user_id: params?.user_id ? params?.user_id : getUserId(),
            employee_canteen_tokens_usage_pk: params?.employee_canteen_tokens_usage_pk || null
        }
    })
    .then((res) => {
        return { message: "Record retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve record", hasError: true, data: err?.response?.data }
    });
};

export const AddEmployeeCanteenRecordHelper = async (params) => {
    return await axiosInstance(`/canteen/addEmployeeCanteenRecord`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name ? params?.domain_name : getDomain(),
            uuid: params?.uuid,
            token_amt: params?.token_amt,
            comment: params?.comment || "",
        }
    })
    .then((res) => {
        return { message: "Record added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to add record", hasError: true, data: err?.response?.data }
    });
};
export const GetCanteenTokenBalanceHelper = async (params) => {
    return await axiosInstance(`/canteen/getCanteenTokenBalance`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name ? params?.domain_name : getDomain(),
            uuid: params?.uuid,
        }
    })
    .then((res) => {
        return { message: "Balance retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve balance", hasError: true, data: err?.response?.data }
    });
};

export const AddVisitorTokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/canteen/addVisitorCanteenManagement`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            uuid: params?.uuid,
            record_date: params?.record_date,
            canteen_status: params?.canteen_status,
            visitors_management_pk: params?.visitors_management_pk,
            comments: params?.comments || "",
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Meal token assigned successfully");
        return { message: "Meal token assigned successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to assign Token", hasError: true, data: err?.response?.data }
    });
};

export const GetCanteenTeamSizeUtilizedHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/canteen/getCanteenTeamsizeUtilized`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain_name ? params?.domain_name : getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Balance retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve balance", hasError: true, data: err?.response?.data }
    });
};